export default "__VITE_ASSET__BJo6e_t7__"